import { MatIconModule } from '@angular/material/icon';
import { Component, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.scss'],
})
export class ContactoComponent implements OnInit {
  telefono: string = '934004302';
  email: string = 'informacion@bancsabadell.com';

  constructor(public dialogRef: MatDialogRef<ContactoComponent>) {}

  ngOnInit() {}
}
